/* eslint import/no-cycle: 0 */
import { RouteGenerator } from 'client/util/Constants';
import { addRootClasses } from '@jumpcloud/ui-components';
import AdminGoogleRegistration from 'client/signup/AdminGoogleRegistration/AdminGoogleRegistration.vue';
import AdminSignup from 'client/signup/AdminSignup/AdminSignup.vue';
import ConfirmContainer from 'client/signup/ConfirmContainer.vue';
import ConfirmPartnerContainer from 'client/signup/components/ConfirmPartnerContainer.vue';
import SignupConstants from 'client/util/Constants/SignupConstants';
import VerifiedContainer from 'client/signup/VerifiedContainer.vue';
import VueRouter from 'vue-router';
import store from '../store/signupStore';

const { login } = RouteGenerator;
const { confirmPartnerRouteName } = SignupConstants;

addRootClasses({
  meta: {
    loadLegacyStyles: false,
  },
});

/**
 * This navigation guard prevents routing until all the fields in the step
 * are validated. You can go back from invalid state, but can't go forward.
 * Navigation guards need to be housed in the component that is directly routed to.
 */

export const beforeEnterHelper = (to, from, next) => {
  const { hasLoaded, user } = store.state;
  const fromStep = from.query.step ? parseInt(from.query.step, 10) : 1;
  const toStep = to.query.step ? parseInt(to.query.step, 10) : 1;

  if (from.name === 'SignupConfirm' && toStep > 1) {
    next({
      name: 'AdminSignup',
      query: {
        step: 1,
      },
    });
  }

  if (hasLoaded) {
    if (user.isValid) {
      store.dispatch('setValidation', false);
      next();
    } else if (to.path === login) {
      next();
    } else if (toStep < fromStep) {
      store.dispatch('setValidation', true);
      next();
    } else {
      next(false);
    }
  } else if (toStep !== 1) {
    const goTo = to;
    delete goTo.query.step;
    next(goTo);
  } else {
    next();
  }
};

export const RouterOptions = {
  mode: 'history',
  routes: [
    {
      path: '/signup',
      name: 'AdminSignup',
      component: AdminSignup,
    },
    {
      path: '/signup/confirm',
      name: 'SignupConfirm',
      component: ConfirmContainer,
    },
    {
      path: '/signup/confirm/partner',
      name: confirmPartnerRouteName,
      component: ConfirmPartnerContainer,
    },
    {
      path: '/signup/msp',
      name: 'MspSignup',
      component: AdminSignup,
      props: { isMsp: true },
    },
    {
      path: '/signup/new-org-verification',
      name: 'NewOrgVerification',
      component: AdminGoogleRegistration,
    },
    {
      path: '/signup/verified',
      name: 'SignupVerified',
      component: VerifiedContainer,
    },
  ],
};

const router = new VueRouter(RouterOptions);

router.beforeEach((to, from, next) => beforeEnterHelper(to, from, next));

export default router;
